import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import { SchoolClassOptionTypes } from 'teacher-ui-client/components/base/select/school-class/options'

export default class BookLibrarySharesIndexController extends Controller {
  queryParams = ['search', 'schoolClassId']

  @tracked search = ''

  @tracked schoolClassId: string | SchoolClassOptionTypes = SchoolClassOptionTypes.My
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/book-library/shares/index': BookLibrarySharesIndexController
  }
}
